module.exports = __webpack_public_path__ + "img/dialog_company.ad71011e.svg";